module.exports = __webpack_public_path__ + "static/img/78e28d13.svg";